import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateDistributorUsers } from '../../store/ducks/tables/actions';

export default function useGetDistributorUsers() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  async function execute(params: {
    page: number;
    rowsPerPage?: number;
    distributorUserId?: any;
    email?: any;
  }) {
    try {
      setLoading(true);
      const response = await api.get(`v1/backoffice/distributor-users`, {
        params: {
          rowsPerPage: params.rowsPerPage || 20,
          page: params.page,
          email: params.email,
        },
      });

      if (response.status === 200) {
        dispatch(populateDistributorUsers(response.data));
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
